module.exports = __webpack_public_path__ + "img/auto2.17377746.jpg";